import { VirtualizedTable as BaseVirtualizedTable } from '@round/creatorbase-ui';
import { ComponentProps } from 'react';
import cn from 'classnames';

import styles from './VirtualizedTable.module.css';
import { RowData } from '@tanstack/react-table';

type Props<TData extends RowData> = ComponentProps<typeof BaseVirtualizedTable<TData>>;

const VirtualizedTable = <TData extends RowData>({ className, containerClassName, ...props }: Props<TData>) => {
    return (
        <BaseVirtualizedTable
            {...props}
            className={cn(styles.table, className)}
            containerClassName={cn(styles.tableContainer, containerClassName)}
        />
    );
};

export default VirtualizedTable;
